import React, { useEffect, useRef, useState } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import { useForm } from "react-hook-form";
import { AiOutlineDelete, AiOutlineCopy } from "react-icons/ai";
import { CiEdit } from "react-icons/ci";
import { ToastContainer } from 'react-toastify';
import { RxCross2 } from 'react-icons/rx';
import swal from 'sweetalert';
import HeaderDashboard from '../../Components/DashboardComponent/headerdashboard/HeaderDashboard';
import Sidebar from '../../Components/DashboardComponent/sidebar/Sidebar';
import HttpHelper from '../../service/httpService';
import DashboardWrapper from './DashboardWrapper';
import { hasAddPermission, hasDeletePermission, hasEditPermission, hasReadPermission, initilizeUserInfo } from "../../service/userService";

const SecurityObjectName = 'Website.MenuItems';

const DashboardMenuItems = (props) => {

    const [hasReadPermissionUser, setHasReadPermissionUser] = useState('');
    const [hasAddPermissionUser, setHasAddPermissionUser] = useState('');
    const [hasEditPermissionUser, setHasEditPermissionUser] = useState('');
    const [hasDeletePermissionUser, setHasDeletePermissionUser] = useState('');

    const getAllPermission = () => {
        setHasReadPermissionUser(hasReadPermission(SecurityObjectName));
        setHasAddPermissionUser(hasAddPermission(SecurityObjectName));
        setHasEditPermissionUser(hasEditPermission(SecurityObjectName));
        setHasDeletePermissionUser(hasDeletePermission(SecurityObjectName));
    }
    const [isActive, setIsActive] = useState(true);
    const [popupAddEdit, setPopupAddEdit] = useState(false);
    const [loaderApi, setLoaderApi] = useState(false);

    const [items, setItems] = useState([]);
    const [pages, setPages] = useState({});
    const [menus, setMenus] = useState([]);
    const [activeIndex, setActiveIndex] = useState(-1);
    const [isEditing, setIsEditing] = useState(false);
    const { register, handleSubmit, watch, reset, setValue, formState: { errors },
        clearErrors } = useForm({});
    const [isParent, setIsParent] = useState(false);
    const [haveExternalLink, setHaveExternalLink] = useState(false);

    const [rowVersion, setRowVersion] = useState('');
    const [fileId, setFileId] = useState('');
    const [menuId, setMenuId] = useState('');
    const [primaryKeyEncrypted, setPrimaryKeyEncrypted] = useState('');
    const AccordianHandle = useRef();
    const [accordianStatus, setAccordianStatus] = useState('0');

    const onSubmit = async (data, event) => {
        data.isActive = isActive;
        setLoaderApi(true);
        const formData = new FormData();
        formData.append("Title", data.title);
        if (haveExternalLink === true) {
            formData.append("ExternalLink", data.ExternalLink);
        } else {
            formData.append("pageId", Number(data.pageId));
        }
        if (isParent === false) {
            formData.append("parentId", data.parentId);
        }
        if (isEditing === true) {
            MenuUpdate(data);
        } else {
            delete data.menuId;

            if (data.parentId === '') {
                data.parentId = null;
            }
            if (data.pageId === '') {
                data.pageId = null;
            }
            data = { ...data, pageId: Number(data.pageId), menuOrder: Number(data.menuOrder), FileId: null };
            await HttpHelper.post("Menu", data).then((response) => {
                setLoaderApi(false);
                setPopupAddEdit(false);
                event.target.reset();
                setIsParent(false);
                setIsActive(false);
                props.showToast('success', 'Menu added successfully');
                GetMenus();
            }).catch((error) => {
                console.log(error);
            })
        }
    };
    const MenuUpdate = async (data) => {
        Object.assign(data,
            { rowVersion: rowVersion },
            { menuId: menuId },
            { FileId: fileId }
        );
        if (data.pageId === '') {
            Object.assign(data,
                { pageId: null }
            );
        }
        if (data.parentId === '') {
            Object.assign(data,
                { parentId: null }
            );
        }
        if (haveExternalLink === true) {
            Object.assign(data,
                { pageId: null }
            );
        }
        if (isParent === true) {
            Object.assign(data,
                { parentId: null }
            );
        }

        await HttpHelper.put("Menu", data).then((response) => {
            if (response.status === 200) {
            } else {
                console.log('error while uploading the image');
            }
            setLoaderApi(false);
         
            setPopupAddEdit(false);
            setValue('title', '');
            setValue('menuOrder', '');
            setIsParent(false);
            
            setHaveExternalLink(false);
            setValue('ExternalLink', '');
            setValue('parentId', '');
            setValue('pageId', '');
            setIsEditing(false);

            props.showToast('success', 'Menu Updated Succesfully');
            GetMenus()

        }).catch((error) => {
            console.log(error);
            setIsEditing(false);
            setLoaderApi(false);
            setPopupAddEdit(false);
        })
    }
    const handleClick = (index) => {
        setActiveIndex(index === activeIndex ? -1 : index);
    };
    const GetPages = async () => {
        await HttpHelper.get("page").then((response) => {
            if (response.status === 200) {
                setPages(response.data.data);
            }
        }).catch((error) => {
            console.log(error);
        })
    }
    const GetMenus = async () => {
        setLoaderApi(true);
        await HttpHelper.get("menu/GetMenuTree").then((response) => {
            if (response.status === 200) {
                setMenus(response.data.sort((a, b) => a.menuOrder - b.menuOrder));
                setItems(response.data.sort((a, b) => a.menuOrder - b.menuOrder));
                getAllPermission();
                setIsEditing(true);
                setLoaderApi(false);
            }
        }).catch((error) => {
            console.log(error);
        })
    }
    const updateMenuById = async (menuId) => {
        setPopupAddEdit(true);
        setLoaderApi(true);
        await HttpHelper.get("menu/" + menuId).then((response) => {
            if (response.status === 200) {
                setIsEditing(true);
                setValue('menuId', response.data.menuId);
                setValue('menuOrder', response.data.menuOrder);
                setValue("title", response.data.title);
                if (response.data.parentId === null) {
                    setIsParent(true);
                } else {
                    setValue('parentId', response.data.parentId);
                    setIsParent(false);
                }
                if (response.data.externalLink === null || response.data.externalLink === '') {
                    setValue('pageId', response.data.pageId);
                } else {
                    setValue('ExternalLink', response.data.externalLink);
                    setHaveExternalLink(true);
                }
                setIsActive(response.data.isActive);
                setRowVersion(response.data.rowVersion)
                setFileId(response.data.fileId)
                setPrimaryKeyEncrypted(response.data.primaryKeyEncrypted);
                setMenuId(response.data.menuId);
                accordianStatusHandle();
                setLoaderApi(false);
                setShowLoader(false);
            }
        }).catch((error) => {
            console.log(error);
        })
    }
    const deleteMenuById = async (menuId) => {
        if (menuId === null || menuId === undefined) {
            return false;
        }
        swal("Are you sure, you want to delete this menu?", { buttons: ["Cancel", "Yes"] })
            .then(async (willDelete) => {
                if (willDelete) {
                    await HttpHelper.delete("menu/" + menuId).then((response) => {
                        if (response.status === 200) {
                            setIsEditing(true);
                            setValue('menuId', response.data.menuId);
                            setValue("title", response.data.title);
                            if (response.data.parentId === null) {
                                setIsParent(true);
                            } else {
                                setValue('parentId', response.data.parentId);
                                setIsParent(false);
                            }
                            if (response.data.externalLink === null) {
                                setValue('pageId', response.data.pageId);
                            } else {
                                setValue('ExternalLink', response.data.externalLink);
                                setHaveExternalLink(true);
                            }
                        }
                        GetMenus()
                    }).catch((error) => {
                        console.log(error);
                    })


                }
            });
    }
    const accordianStatusHandle = (e, elem) => {
        if (elem === undefined) {
            if (accordianStatus === '0') {
                setAccordianStatus('1');
            } else {
                setAccordianStatus('0');
            }
        } else {
            setAccordianStatus(elem);
        }
    }
    const copyClickedText = (e) => {
        navigator.clipboard.writeText(e.currentTarget.innerText);
        alert("Copied the text: " + e.currentTarget.innerText);
    }
    useEffect(() => {
        GetPages();
        GetMenus();
    }, [])

    return (
        <DashboardWrapper>
            <ToastContainer />
            <div className="DashboardWrapperChild">
                <Sidebar />
                <div className="contentWrapper">
                    <HeaderDashboard title="Menu Items" />
                    <div className="container-fluid mt-80 p-0">
                        <div className="row">
                            {hasEditPermissionUser || hasAddPermissionUser ? <div className="col-md-12 mb-2">
                                <h5>Predefined Links</h5>
                                <ul className="predefinedLinks">
                                    <li onClick={(e) => copyClickedText(e)}>about <span title="Click for copy"><AiOutlineCopy /></span></li>
                                    <li onClick={(e) => copyClickedText(e)}>services <span title="Click for copy"><AiOutlineCopy /></span></li>
                                    <li onClick={(e) => copyClickedText(e)}>location <span title="Click for copy"><AiOutlineCopy /></span></li>
                                    <li onClick={(e) => copyClickedText(e)}>inquiry-form <span title="Click for copy"><AiOutlineCopy /></span></li>
                                    <li onClick={(e) => copyClickedText(e)}>clients <span title="Click for copy"><AiOutlineCopy /></span></li>
                                    <li onClick={(e) => copyClickedText(e)}>contact <span title="Click for copy"><AiOutlineCopy /></span></li>
                                </ul>
                            </div> : ''}
                            <div className="col-auto">
                                {isEditing === true ? <button onClick={(e) => {
                                    setPopupAddEdit(true);
                                    setIsEditing(false)
                                    setValue('title', '');
                                    setValue('menuOrder', '');
                                    setValue('menuOrder', '');
                                    accordianStatusHandle(e, '1');
                                }} className="btn btnSave">Add Menu</button> : ''}
                            </div>
                            <div className="col-md-12 mb-2">
                            </div>
                            {hasAddPermissionUser == true && loaderApi == false ? <div className="col-md-12 table-responsive">
                                <div className="cardBox cardTableWrapperDashboard cardTableGridNewDesign">
                                    <table className="table tableCustomized table-striped">
                                        <thead>
                                            <tr>
                                                <th>
                                                    Order
                                                </th>
                                                <th>
                                                    Menu
                                                </th>
                                                <th>
                                                    Parent Menu
                                                </th>
                                                <th>
                                                    Is Active?
                                                </th>
                                                <th style={{ verticalAlign: 'center', textAlign: 'center' }}>
                                                    Action
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                menus && menus.length > 0 ? menus.map((menu, key) => {
                                                    return (
                                                        <tr key={key}>
                                                            <td>{menu.parentTitle != '' ? '' : menu.menuOrder} </td>
                                                            <td>{menu.title}</td>
                                                            <td>{menu.parentTitle}</td>
                                                            <td>
                                                                {menu.isActive == 1 ? 'Yes' : 'No'}
                                                            </td>
                                                            <td >
                                                                {
                                                                    hasEditPermissionUser == true ? <CiEdit onClick={() => { updateMenuById(menu.menuId) }} /> : ''
                                                                }
                                                                {
                                                                    (hasDeletePermissionUser == true ? <AiOutlineDelete onClick={() => { deleteMenuById(menu.menuId) }} /> : '')

                                                                }
                                                            </td>
                                                        </tr>
                                                    );
                                                }) : null
                                            }

                                        </tbody>
                                    </table>
                                </div>
                            </div> : loaderApi == false && hasAddPermissionUser == false ? <div className="NoPermission">Don't Have Permisiion</div> : <div className="loaderApi">
                                <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" stroke="#000">
                                    <g fill="none" fill-rule="evenodd">
                                        <g transform="translate(1 1)" stroke-width="2">
                                            <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
                                            <path d="M36 18c0-9.94-8.06-18-18-18">
                                                <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
                                            </path>
                                        </g>
                                    </g>
                                </svg>
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            {
                hasAddPermissionUser || hasEditPermissionUser ? <div className="popupEditAndAddFormWrapper" style={{ right: `${popupAddEdit == true ? '0' : '-100%'}` }}>
                    <div className="popupEditAndAddForm">
                        <div className="popupEditAndAddFormCloseButton" onClick={() => {
                            setPopupAddEdit(false);
                            setIsEditing(true);
                        }} >
                            <RxCross2 />
                        </div>

                        {loaderApi == true ? <div className="loaderApi">
                            <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" stroke="#000">
                                <g fill="none" fill-rule="evenodd">
                                    <g transform="translate(1 1)" stroke-width="2">
                                        <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
                                        <path d="M36 18c0-9.94-8.06-18-18-18">
                                            <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
                                        </path>
                                    </g>
                                </g>
                            </svg>
                        </div> : <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="cardBox">
                                <h4>{isEditing === true ? "Update Menu" : "Create Menu"}</h4>
                                <div className="row">
                                    <div className="col-md-12">
                                        <label>Title : <span class="requiredAstric"> *</span></label>
                                        <input type="text"  {...register("title", { required: true })} className="border mb-2" placeholder="Menu title" aria-invalid={errors.Heading ? "true" : "false"} />
                                        {errors.title?.type === 'required' && <p className="text-danger" role="alert">Title is required</p>}
                                    </div>
                                    <div className="col-md-12">
                                        <label>Menu Order : <span class="requiredAstric"> *</span></label>
                                        <input type="number"  {...register("menuOrder", { required: true })} className="border mb-2" placeholder="Menu order" aria-invalid={errors.Heading ? "true" : "false"} />
                                        {errors.menuOrder?.type === 'required' && <p className="text-danger" role="alert">Menu Order is required</p>}
                                    </div>
                                    <div className="col-md-6">
                                        <label><input type="checkbox" checked={isParent} onChange={(e) => {
                                            if (e.currentTarget.checked === true) {
                                                setIsParent(true)
                                            } else {
                                                setIsParent(false)
                                            }
                                        }} className="border mb-2" placeholder="Heading" />
                                            &nbsp;Is Parent?</label>

                                    </div>
                                    {
                                        isParent == false ?
                                            <div className="col-md-12">
                                                <label>Parent Menu : <span class="requiredAstric"> *</span></label>
                                                <select className="border mb-2 selectboxEdit" {...register("parentId", { required: isParent === false ? true : false })}>
                                                    <option value="">Select Parent Menu</option>
                                                    {
                                                        menus.length > 0 ?
                                                            menus.map((menu, index) => {
                                                                return (
                                                                    <option key={index} value={menu.menuId}>{menu.title}</option>
                                                                )
                                                            })
                                                            : null
                                                    }
                                                </select>
                                                {errors.parentId?.type === 'required' && <p className="text-danger" role="alert">Parent menu is required</p>}
                                            </div>
                                            : null
                                    }
                                    <div className="col-md-6">
                                        <label><input type="checkbox" checked={haveExternalLink} onChange={(e) => {
                                            if (e.currentTarget.checked === true) {
                                                setHaveExternalLink(true)
                                            } else {
                                                setValue('ExternalLink', '');
                                                setHaveExternalLink(false)
                                            }
                                        }} className="border mb-2" />
                                            &nbsp;Do you have external link?</label>
                                    </div>
                                    {haveExternalLink === true ?
                                        <div className="col-md-6">
                                            <label>External Link : <span class="requiredAstric"> *</span></label>
                                            <input type="text"  {...register("ExternalLink", { required: true })} className="border mb-2" placeholder="External Link" aria-invalid={errors.ExternalLink ? "true" : "false"} />
                                            {errors.title?.type === 'required' && <p className="text-danger" role="alert">External link is required</p>}
                                        </div>
                                        :
                                        <div className="col-md-6">
                                            <label>Page : <span class="requiredAstric"> *</span></label>
                                            <select style={{ width: "100%" }} className="border mb-2 selectboxEdit" {...register("pageId", { required: true })}>
                                                <option value="">Select Page</option>
                                                {
                                                    pages.length > 0 ?
                                                        pages.map((page, index) => {
                                                            return (
                                                                <option key={index} value={page.pageId}>{page.title}</option>
                                                            )
                                                        })
                                                        : null
                                                }
                                            </select>
                                            {errors.pageId?.type === 'required' && <p className="text-danger" role="alert">Parent menu is required</p>}
                                        </div>
                                    }
                                    {
                                        isEditing === true ?
                                            <input type='hidden' {...register('menuId', { required: true })} />
                                            : null
                                    }
                                    <div className="col-md-12">
                                        <label>
                                                <input type="checkbox" checked={isActive} className="border mb-2"
                                                onChange={(e) => {
                                                    if (e.currentTarget.checked === true) {
                                                        setIsActive(true);
                                                    } else {
                                                        setIsActive(false);
                                                    }
                                                }} />
                                            &nbsp;Is Active?</label>

                                    </div>
                                    <div className="col-md-12 d-flex justify-content-end mt-6">
                                        <div>
                                            <button className="btn btnSave mt-2">Save</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>}

                    </div>
                </div> : ''
            }
        </DashboardWrapper >
    )
}

export default DashboardMenuItems;